module.exports = {"name":"Glenbeigh Developments Ltd","address":"Aberdeen House, South Road, Haywards Heath, Sussex, RH16 4NG, UK","lat":50.9990976,"lng":-0.1096519,"email":"colinw@glenbeighltd.com","telephone":"020 7917 2761","telephone_link":"+442079172761","description":"","url":"http://www.glenbeighltd.com","location":{"lat":50.9990976,"lng":-0.1096519,"marker":"marker-cobham.png"}}


//////////////////
// WEBPACK FOOTER
// /Users/terrymasher/Development/glenbeigh-ltd/src/data/company-info.json
// module id = 281
// module chunks = 0 1